import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Progress, // YENİ: Progress bileşenini reactstrap'ten import ediyoruz.
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";

import "jspdf-autotable";
import * as XLSX from 'xlsx';
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import {
  getProductSubSubCategory as onGetProductSubSubCategory,
  addProductSubSubCategory as onAddProductSubSubCategory,
  updateSubSubProductCategory as onUpdateSubSubProductCategory,
  deleteProductSubSubCategory as onDeleteProductSubSubCategory,

    addUsersLessonsType as onAddUsersLessonsType,
  addReservation as onAddReservation,

} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Konular | TriMentor Admin PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getSubCategoryID, setSubCategoryID] = useState();
  const [getIsActive, setIsActive] = useState(false);
  const [lessonTypesMap, setLessonTypesMap] = useState(new Map());
  
  // DEĞİŞTİ: Yükleme durumu ve ilerleme yüzdesi için state'ler
  const [loading, setLoading] = useState(false); 
  const [uploadProgress, setUploadProgress] = useState(0); // YENİ: Yükleme yüzdesini tutacak state.

  const [lessonsMap, setLessonsMap] = useState(new Map());


  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Book_Subject_Title) || "",
      sort:(contactEdit && contactEdit.Sort) || ""

    },
    validationSchema: Yup.object({
      title: Yup.string(3).required("Başlığı Giriniz"),

    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Book_Subject_Title: values.title,
          Sort: parseInt(values.sort),
          IsActive:getIsActive,
          Lesson_ID : getSubCategoryID
        };
        dispatch(onUpdateSubSubProductCategory(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          Book_Subject_Title: values["title"],
          Sort: parseInt(values["sort"]),
          IsActive:getIsActive,
          Lesson_ID : getSubCategoryID
        };
        // save new user
        dispatch(onAddProductSubSubCategory(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.productSubSubCategory,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);


  const [getCategory, setCategory] = useState([]);


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      
  
      {
        Header: "Adı",
        accessor: "Book_Subject_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Sıralama",
        accessor: "Sort",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },



      {
        Header: "Aktif Mi?",
        accessor: "IsActive",
        filterable: true,
        Cell: cellProps => {
          return <Status {...cellProps} />;
        },
      },


      {
        Header: "Ders",
        accessor: "Lesson.Lesson_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Sınıf",
        accessor: "Lesson.Users_Lessons_Type.Users_Lessons_Type_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      

      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">



              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleUserClick(userData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

     const handleClick = () => {
    document.getElementById('fileInput').click();
  };


    useEffect(() => {
    const _getInitialDataForImport = async () => {
      try {
        const [lessonTypesResponse, lessonsResponse] = await Promise.all([
          axios.get(`https://trimentoradmin.stechomeyazilim.info:4436/getUsersLessonsType/select/`),
          axios.get(`https://trimentoradmin.stechomeyazilim.info:4436/getLessonEfso2/select/`)
        ]);

        const typesMap = new Map(lessonTypesResponse.data.map(item => {
            const key = item.Users_Lessons_Type_Title.toString().toLowerCase().trim();
            return [key, item.ID];
        }));
        
        const lessonsMap = new Map(lessonsResponse.data.map(item => {
            const key = `${item.Lesson_Title.toString().toLowerCase().trim()}_${item.Users_Lesson_Type_ID}`;
            return [key, item.ID];
        }));

        setLessonTypesMap(typesMap);
        setLessonsMap(lessonsMap);
        
        console.log("Veritabanının güncel hali hafızaya alındı. Tekrar oluşum kontrolü hazır.");
      } catch (error) {
        console.error("İçe aktarma için ön veriler çekilirken hata:", error);
        alert("Sayfa verileri yüklenemedi, Excel aktarımı çalışmayabilir.");
      }
    };

    _getInitialDataForImport();
  }, []);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    setUploadProgress(0);

    const localLessonTypesMap = new Map(lessonTypesMap);
    const localLessonsMap = new Map(lessonsMap);

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const workbook = XLSX.read(event.target.result, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(sheet);
        
        const totalRows = data.length;

        for (let i = 0; i < totalRows; i++) {
          const row = data[i];

          try { // YENİ: Her satırın işlenmesini kapsayan genel bir try...catch bloğu
              const sınıfAdı = row["Sınıf"]?.toString().toLowerCase().trim();
              const dersAdı = row["Ders"]?.toString().toLowerCase().trim();
              
              if (!sınıfAdı || !dersAdı) {
                  console.warn(`Satır ${i + 2} atlanıyor: Eksik 'Sınıf' veya 'Ders' bilgisi.`, row);
                  continue;
              }

              // --- ADIM 1: SINIF BUL VEYA OLUŞTUR ---
              let usersLessonTypeId = localLessonTypesMap.get(sınıfAdı);
              if (!usersLessonTypeId) {
                const newClassPayload = { Users_Lessons_Type_Title: row["Sınıf"].toString().trim() };
                const newClass = await new Promise((resolve, reject) => {
                    dispatch(onAddUsersLessonsType(newClassPayload, resolve, reject));
                });
                usersLessonTypeId = newClass.ID;
                localLessonTypesMap.set(sınıfAdı, usersLessonTypeId);
              }

              // --- ADIM 2: DERS BUL VEYA OLUŞTUR ---
              const lessonMapKey = `${dersAdı}_${usersLessonTypeId}`;
              let lessonId = localLessonsMap.get(lessonMapKey);
              if (!lessonId) {
                const newLessonPayload = { Lesson_Title: row["Ders"].toString().trim(), Users_Lesson_Type_ID: usersLessonTypeId };
                const newLesson = await new Promise((resolve, reject) => {
                    dispatch(onAddReservation(newLessonPayload, resolve, reject));
                });
                
                if (newLesson && newLesson.ID) {
                    lessonId = newLesson.ID;
                    localLessonsMap.set(lessonMapKey, lessonId);
                } else {
                    console.error(`Satır ${i + 2}'deki '${dersAdı}' dersi eklendi AMA ID'si alınamadı.`);
                    continue;
                }
              }

              // --- ADIM 3: HER SATIRI ANA KONU OLARAK EKLE ---
              const konuAdı = row["Konu"]?.toString().trim();
              if (!konuAdı) {
                  console.warn(`Satır ${i + 2} atlanıyor: Eksik 'Konu' bilgisi.`, row);
                  continue;
              }

              const mainSubjectPayload = {
                Book_Subject_Title: konuAdı,
                Sort: parseInt(row["Konu kodu"], 10) || 0,
                Lesson_ID: lessonId,
                IsActive : true
              };
              
              // DEĞİŞTİ: Bu önemli dispatch işlemi artık kendi try...catch bloğu içinde.
              await dispatch(onAddProductSubSubCategory(mainSubjectPayload));

          } catch (rowError) {
              // YENİ: Eğer yukarıdaki adımlardan herhangi birinde hata olursa burası çalışır.
              console.error(`Excel'in ${i + 2}. satırı işlenirken bir hata oluştu ve bu satır atlandı. Hata:`, rowError, "İşlenen Veri:", row);
              // continue; komutuna gerek yok çünkü döngü zaten bir sonraki adıma geçecek.
          } finally {
              // YENİ: Satırda hata olsa da olmasa da ilerleme çubuğu güncellenir.
              const progress = ((i + 1) / totalRows) * 100;
              setUploadProgress(progress);
          }
        }
        
        alert("Excel içe aktarma işlemi tamamlandı!");

      } catch (err) {
        console.error("Excel dosyası işlenirken genel bir hata oluştu:", err);
        alert("Excel dosyası işlenirken bir hata oluştu. Lütfen konsolu kontrol edin.");
      } finally {
        setLoading(false);
        setUploadProgress(0);
        dispatch(onGetProductSubSubCategory());
      }
    };
    reader.readAsBinaryString(file);
    e.target.value = null;
  };

  const _getAuthData = async () => {

    await axios.get(`https://trimentoradmin.stechomeyazilim.info:4436/getLessonEfso2/select/`)
      .then((res) => {
        setCategory(res.data)
      })
  }

  useEffect(() => {
    _getAuthData()
    if (users && !users.length) {
      dispatch(onGetProductSubSubCategory());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };

  const handleUserClick = (arg) => {
    const user = arg;
    setEditContact(user);
    setIsEdit(true);
    setSubCategoryID(user.Lesson_ID)
    setIsActive(user.IsActive)
    toggle();
  };

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteProductSubSubCategory(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceSubCategory = arg => {
    setSubCategoryID(arg.target.value)
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Konu Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                
                {/* DEĞİŞTİ: Yükleme göstergesini progress bar ile değiştiriyoruz */}
                {loading && (
                    <div className="mb-4">
                      <div className="d-flex justify-content-between mb-1">
                        <span>Excel Dosyası İşleniyor...</span>
                        <span>{Math.round(uploadProgress)}%</span>
                      </div>
                      <Progress value={uploadProgress} color="success" />
                    </div>
                )}


             <button  className="btn-rounded  mb-2 me-2" onClick={handleClick} disabled={loading}>
                {/* YENİ: Yükleme sırasında butonu pasif hale getiriyoruz */}
                {loading ? 'İşleniyor...' : 'Excel Dosyasını Yükle'}
             </button>
      <input
        id="fileInput"
        type="file"
        accept=".xlsx, .xls"
        style={{ display: 'none' }}
        onChange={handleFileUpload}
      />

                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddProductCategory={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Kategori Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Ürün Kategori Başlığını Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Sıralama</Label>
                              <Input
                                name="sort"
                                label="sort"
                                type="number"
                                placeholder="Sıra No Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.sort || ""}
                                invalid={
                                  validation.touched.sort &&
                                    validation.errors.sort
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.sort &&
                                validation.errors.sort ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.sort}
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">Ders Seçiniz</Label>
                              <Input
                                name="getSubCategoryID"
                                type="select"
                                className="form-select"
                                defaultValue={getSubCategoryID}
                                onChange={(text) => _setChoiceSubCategory(text)}
                                value={
                                  getSubCategoryID
                                }>
                                 <option value="">Lütfen Seçim Yapınız</option>
                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Lesson_Title}</option>
                                ))}

                              </Input>
                            </div>
                          <div className="d-flex">
                          <div className="square-switch">
                            <input
                              type="checkbox"
                              id="square-switch1"
                              className="switch"
                              defaultChecked={getIsActive}
                              onChange={() =>
                                setIsActive(!getIsActive)
                              }
                            />
                            <label
                         htmlFor="square-switch1"
                              data-on-label="Aktif "
                              data-off-label="Pasif"
                            />
                          </div>
                        </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);